import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';

import BollingerBandChart from 'app/views/synthetics/components/BollingerBandChart';
import { checkSeriesDataForFailure } from 'app/views/synthetics/utils/syntheticsUtils';

import withTrendChart from './withTrendChart';

@withTrendChart
@withTheme
@inject('$app', '$dataviews')
@observer
class LatencyTimeSeries extends BollingerBandChart {
  renderData() {
    if (this.chart) {
      const { data, seriesName, xAxisMin, xAxisMax, delta } = this.props;

      if (!data) {
        return;
      }

      const averages = [];
      const stddevs = [];
      const zones = [];
      let currHealth;

      const offset = delta || 60000;

      data.forEach((point, i) => {
        const { time, latency_health, avg_latency, rolling_avg_latency, rolling_stddev_latency } = point;

        if (checkSeriesDataForFailure(point)) {
          averages.push({ time, x: time, y: null });
          stddevs.push([time, null, null]);
        } else {
          averages.push({
            time,
            x: time,
            y: avg_latency / 1000,
            marker: {
              enabled: checkSeriesDataForFailure(data[i - 1]) || checkSeriesDataForFailure(data[i + 1])
            }
          });
          stddevs.push([
            time,
            Math.max(0, (rolling_avg_latency - rolling_stddev_latency) / 1000),
            (rolling_avg_latency + rolling_stddev_latency) / 1000
          ]);
        }

        if (currHealth !== latency_health) {
          zones.push({
            value: time - offset,
            color: this.getColor(currHealth),
            fillColor: this.getFillColor(currHealth)
          });
          currHealth = latency_health;
        }
      });

      zones.push({ color: this.getColor(currHealth), fillColor: this.getFillColor(currHealth) });

      const marker = {
        enabled: false,
        states: {
          select: {
            fillColor: this.getColor(currHealth),
            lineColor: 'rgba(255, 255, 255, 0.5)',
            lineWidth: 5,
            radius: 8
          }
        }
      };

      this.setState({
        chartOptions: {
          yAxis: {
            min: 0,
            offset: 20
          },
          xAxis: {
            min: xAxisMin,
            max: xAxisMax
          },
          series: [
            { data: averages, zones, name: seriesName || 'Latency', marker },
            { data: stddevs, zones, marker }
          ]
        }
      });
    }
  }
}

export default LatencyTimeSeries;
